'use client';

import React from 'react';
import { isBeforeNowInTimeZone } from '@skin-seoul/service';
import { GGUSection } from '@skin-seoul/shared-components';
import { CAMPAIGN_SCHEDULE } from '@skin-seoul/service';
const GGUCampaignSection = () => {
  return <>{isBeforeNowInTimeZone(CAMPAIGN_SCHEDULE.GGU.endDate, CAMPAIGN_SCHEDULE.GGU.timeZone) && <GGUSection />}</>;
};
export default GGUCampaignSection;